export default "__VITE_ASSET__c514b934__"